"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "TV-Mode",
    transform: "translate(0.000000, -1.000000)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      id: "Path",
      points: "0 0 24 0 24 24 0 24"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10.2551191,17.8598149 L14.9120351,15.4280007 C15.6959883,15.0226984 15.6959883,13.9881108 14.9120351,13.5721426 L10.2551191,11.1403284 C9.4711659,10.7350261 8.5,11.2576528 8.5,12.0682575 L8.5,16.9212199 C8.5,17.7424905 9.4711659,18.2651172 10.2551191,17.8598149 Z M21.8181818,5.22222222 L13.5381818,5.22222222 L16.7454545,1.95555556 C16.9636364,1.73333333 16.9636364,1.38888889 16.7454545,1.16666667 C16.5272727,0.944444444 16.1890909,0.944444444 15.9709091,1.16666667 L12,5.21111111 L8.02909091,1.16666667 C7.81090909,0.944444444 7.47272727,0.944444444 7.25454545,1.16666667 C7.03636364,1.38888889 7.03636364,1.73333333 7.25454545,1.95555556 L10.4618182,5.22222222 L2.18181818,5.22222222 C0.981818182,5.22222222 0,6.21111111 0,7.44444444 L0,20.7777778 C0,22 0.981818182,23 2.18181818,23 L21.8181818,23 C23.0181818,23 24,22 24,20.7777778 L24,7.44444444 C24,6.21111111 23.0181818,5.22222222 21.8181818,5.22222222 Z M20.8888889,21 L3.11111111,21 C2.5,21 2,20.5125 2,19.9166667 L2,9.08333333 C2,8.4875 2.5,8 3.11111111,8 L20.8888889,8 C21.5,8 22,8.4875 22,9.08333333 L22,19.9166667 C22,20.5125 21.5,21 20.8888889,21 Z",
      id: "Shape",
      fill: "currentColor"
    })]
  })
}));